var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "loading-position" }, [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        attrs: { src: require("./images/img_loading.gif"), alt: "" }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.step == 0,
            expression: "step == 0"
          }
        ],
        staticClass: "mask_contents-wrap with_floting"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "list_mask" }, [
          _c("div", { staticClass: "list-item" }, [
            _c("div", { staticClass: "choice-area" }, [
              _c("span", { staticClass: "form_element-radio no_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.qty,
                      expression: "qty"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "choice2",
                    name: "choice",
                    value: "qty1"
                  },
                  domProps: { checked: _vm._q(_vm.qty, "qty1") },
                  on: {
                    change: function($event) {
                      _vm.qty = "qty1"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "sp_chk focus", attrs: { for: "choice2" } },
                  [_vm._v("선택")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img_product" }, [
              _c("img", {
                attrs: { src: require("./images/mask_big.jpg"), alt: "" },
                on: {
                  click: function($event) {
                    _vm.qty = "qty1"
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-item" }, [
            _c("div", { staticClass: "choice-area" }, [
              _c("span", { staticClass: "form_element-radio no_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.qty,
                      expression: "qty"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "choice1",
                    name: "choice",
                    value: "qty2"
                  },
                  domProps: { checked: _vm._q(_vm.qty, "qty2") },
                  on: {
                    change: function($event) {
                      _vm.qty = "qty2"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "sp_chk focus", attrs: { for: "choice1" } },
                  [_vm._v("선택")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img_product" }, [
              _c("img", {
                attrs: { src: require("./images/mask_small.jpg"), alt: "" },
                on: {
                  click: function($event) {
                    _vm.qty = "qty2"
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(3)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reservation-area" }, [
          _c("h2", { staticClass: "title_type-b" }, [
            _vm._v("예약자 정보 입력")
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "new-join-wrap" }, [
              _c("div", { staticClass: "ipt_area" }, [
                _c(
                  "label",
                  { staticClass: "form_label", attrs: { for: "ko_abo" } },
                  [_vm._v("ABO 번호")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.abo_no,
                      expression: "abo_no"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###########",
                      expression: "'###########'"
                    }
                  ],
                  staticClass: "form_ipt",
                  attrs: { type: "tel", id: "ko_abo" },
                  domProps: { value: _vm.abo_no },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.abo_no = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ipt_area" }, [
                _c(
                  "label",
                  { staticClass: "form_label", attrs: { for: "ko_name" } },
                  [_vm._v("이름")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form_ipt",
                  attrs: { type: "text", id: "ko_name" },
                  domProps: { value: _vm.name },
                  on: { input: _vm.maxlengthName }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ipt_area" }, [
                _c(
                  "label",
                  { staticClass: "form_label", attrs: { for: "phone_number" } },
                  [_vm._v("휴대폰 번호(-없이 입력)")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###########",
                      expression: "'###########'"
                    }
                  ],
                  staticClass: "form_ipt check_hyphen",
                  attrs: { type: "tel", id: "phone_number" },
                  domProps: { value: _vm.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "title_type-b" }, [
            _vm._v("약관 및 개인정보 동의")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box_terms" }, [
            _c("div", { staticClass: "terms-item" }, [
              _c("div", { staticClass: "txt_terms" }, [
                _c("span", { staticClass: "form_element-checkbox no_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.terms1,
                        expression: "terms1"
                      }
                    ],
                    attrs: { type: "checkbox", id: "agree1" },
                    domProps: {
                      checked: Array.isArray(_vm.terms1)
                        ? _vm._i(_vm.terms1, null) > -1
                        : _vm.terms1
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.terms1,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.terms1 = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.terms1 = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.terms1 = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "sp_chk focus", attrs: { for: "agree1" } },
                    [_vm._v("agree")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "sp_chk focus", attrs: { for: "agree1" } },
                  [_vm._v(" [필수] 개인정보 수집/이용 동의서")]
                )
              ]),
              _vm._v(" "),
              _vm._m(4)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "terms-item" }, [
              _c("div", { staticClass: "txt_terms" }, [
                _c("span", { staticClass: "form_element-checkbox no_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.terms2,
                        expression: "terms2"
                      }
                    ],
                    attrs: { type: "checkbox", id: "agree2" },
                    domProps: {
                      checked: Array.isArray(_vm.terms2)
                        ? _vm._i(_vm.terms2, null) > -1
                        : _vm.terms2
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.terms2,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.terms2 = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.terms2 = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.terms2 = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "sp_chk focus", attrs: { for: "agree2" } },
                    [_vm._v("agree")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "sp_chk focus", attrs: { for: "agree2" } },
                  [_vm._v(" [필수] 이용약관")]
                )
              ]),
              _vm._v(" "),
              _vm._m(5)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-area" }, [
          _c(
            "button",
            {
              staticClass: "btn_type-a",
              attrs: { type: "button", disabled: _vm.clicked },
              on: { click: _vm.submit }
            },
            [_vm._v("예약 신청")]
          )
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _vm._m(7)
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.step == 1,
            expression: "step == 1"
          }
        ],
        staticClass: "mask_contents-wrap"
      },
      [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "reservation-info" }, [
          _c("h2", { staticClass: "title_type-b" }, [_vm._v("예약 정보")]),
          _vm._v(" "),
          _c("dl", { staticClass: "reservation_data" }, [
            _c("dt", { staticClass: "reservation_title" }, [
              _vm._v("예약 코드")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "reservation_value" }, [
              _vm._v(_vm._s(_vm.c_seq))
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "reservation_data" }, [
            _c("dt", { staticClass: "reservation_title" }, [_vm._v("예약일")]),
            _vm._v(" "),
            _c("dd", { staticClass: "reservation_value" }, [
              _vm._v(_vm._s(_vm.c_date))
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "reservation_data" }, [
            _c("dt", { staticClass: "reservation_title" }, [
              _vm._v("ABO 번호")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "reservation_value" }, [
              _vm._v(_vm._s(_vm.c_abo_no))
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "reservation_data" }, [
            _c("dt", { staticClass: "reservation_title" }, [_vm._v("이름")]),
            _vm._v(" "),
            _c("dd", { staticClass: "reservation_value" }, [
              _vm._v(_vm._s(_vm.c_name))
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "reservation_data" }, [
            _c("dt", { staticClass: "reservation_title" }, [
              _vm._v("휴대폰 번호")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "reservation_value" }, [
              _vm._v(_vm._s(_vm.c_phone))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reservation_product" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.c_qty1 == "1",
                  expression: "c_qty1 == '1'"
                }
              ],
              staticClass: "product_img"
            },
            [
              _c("img", {
                attrs: { src: require("./images/mask_big.jpg"), alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.c_qty2 == "1",
                  expression: "c_qty2 == '1'"
                }
              ],
              staticClass: "product_img"
            },
            [
              _c("img", {
                attrs: { src: require("./images/mask_small.jpg"), alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "product_data" }, [
            _c("p", { staticClass: "product_name" }, [
              _vm._v(
                "엣모스피어 스카이 미세먼지 마스크 KF94 " +
                  _vm._s(_vm.c_qty1 == "1" ? "대형" : "소형") +
                  " (30매)"
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "product_sku" }, [
              _vm._v(
                "SKU : " + _vm._s(_vm.c_qty1 == "1" ? "295882K" : "295883K")
              )
            ]),
            _vm._v(" "),
            _vm._m(9)
          ])
        ]),
        _vm._v(" "),
        _vm._m(10)
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "layer_close",
        attrs: { type: "button" },
        on: { click: _vm.redirectHome }
      },
      [_vm._v("닫기")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "title_type-a" }, [
      _vm._v("엣모스피어 스카이 "),
      _c("span", { staticClass: "m_block" }, [
        _vm._v("미세먼지 마스크 KF94 (30매)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mask-limit" }, [
      _vm._v("마스크 공급에 제한이 있어 "),
      _c("span", { staticClass: "m_block" }, [
        _vm._v("대형과 소형 중 1개만 예약 가능합니다.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "product_info" }, [
      _c("dt", { staticClass: "txt_product" }, [_vm._v("대형 (295882K)")]),
      _vm._v(" "),
      _c("dd", { staticClass: "txt_price-content" }, [
        _c("span", { staticClass: "price_value" }, [_vm._v("26,000")]),
        _vm._v("원")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "product_info" }, [
      _c("dt", { staticClass: "txt_product" }, [_vm._v("소형 (295883K)")]),
      _vm._v(" "),
      _c("dd", { staticClass: "txt_price-content" }, [
        _c("span", { staticClass: "price_value" }, [_vm._v("26,000")]),
        _vm._v("원")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "terms_agree" }, [
      _c(
        "button",
        { staticClass: "link_allview agree_pop01", attrs: { type: "button" } },
        [_vm._v("전체보기")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "terms_agree" }, [
      _c(
        "button",
        { staticClass: "link_allview agree_pop02", attrs: { type: "button" } },
        [_vm._v("전체보기")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agree_content-a layer_agree" }, [
      _c("div", { staticClass: "box_agree" }, [
        _c("h1", { staticClass: "title_agree" }, [
          _vm._v("[필수] 개인정보 수집/이용 동의서")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "agree_contents" }, [
          _c("p", { staticClass: "txt_agree-a" }, [
            _vm._v(
              "한국암웨이㈜는 엣모스피어 스카이 미세먼지마스크 구매 예약 신청을 위하여 다음과 같이 귀하의 개인정보를 수집, 이용합니다."
            )
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "agree_data" }, [
            _c("dt", { staticClass: "txt_sub-title" }, [
              _vm._v("개인정보의 수집 및 이용 목적")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "txt_content" }, [
              _vm._v("신청자 본인 식별 및 구매권한 부여")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "txt_content" }, [
              _vm._v(
                "신청자 구매 가능일 및 구매 가능한 링크 관련 고지사항 전달"
              )
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "agree_data" }, [
            _c("dt", { staticClass: "txt_sub-title" }, [
              _vm._v("수집하는 개인정보의 항목")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "txt_content" }, [
              _vm._v("ABO 번호, 성명, 휴대폰 번호")
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "agree_data" }, [
            _c("dt", { staticClass: "txt_sub-title" }, [
              _vm._v("개인정보의 보유 및 이용기간")
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "txt_content" }, [
              _vm._v("개인정보 수집 후 3개월 간 보유")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_agree-b" }, [
            _vm._v(
              "※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 엣모스피어 스카이 미세먼지마스크 구매예약 신청이 불가합니다."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_agree-c" }, [
            _vm._v("본인은 위 개인정보 수집 ∙ 이용에 동의합니다.")
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "agree_layer_close", attrs: { type: "button" } },
          [_vm._v("닫기")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agree_content-b layer_agree" }, [
      _c("div", { staticClass: "box_agree" }, [
        _c("h1", { staticClass: "title_agree" }, [_vm._v("[필수] 이용약관")]),
        _vm._v(" "),
        _c("div", { staticClass: "agree_contents" }, [
          _c("p", { staticClass: "txt_agree-b" }, [_vm._v("1. 목적")]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_agree-c" }, [
            _vm._v(
              "이 약관은 한국암웨이에서 제공하는 엣모스피어 스카이 미세먼지마스크 구매 예약 서비스 (이하 “서비스”라 한다)를 이용함에 있어 Amway와 사용자의 권리와 의무 및 책임사항을 규정함을 목적으로 한다."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_agree-b" }, [_vm._v("2. 서비스 정의")]),
          _vm._v(" "),
          _c("ul", { staticClass: "list_agree" }, [
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "1) Amway는 사용자에게 엣모스피어 스카이 미세먼지마스크 구매 예약을 할 수 있도록 www.amway.co.kr 사이트 및 Amway 앱에서 신청 화면을 제공한다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "2) 사용자는 구매 예약 신청 시 구매할 수량과 개인정보(ABO번호, 성명, 휴대폰 번호)를 신청 화면에 입력한다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "3) 사용자가 구매 예약 신청 완료 후, Amway는 수집된 사용자 정보와 Amway에서 보유하고 있는 회원정보를 비교하여 구매 가능한 사용자를 식별한다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "4) Amway는 Amway 회원으로 식별된 사용자에게 구매 가능한 날짜 및 구매링크에 대한 안내를 SMS 및 Amway 사이트 맞춤메시지를 통해 제공한다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "5) 사용자는 구매링크 접속했을 때 구매 예약했던 수량의 제품을 확인할 수 있으며 Amway 사이트 주문 절차에 따라 구매할 수 있다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "6) 사용자는 구매링크를 받은 후 3일 이내 구매하지 않는 경우, 구매 가능 권한이 소멸되며 구매할 수 없다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "7) 사용자가 구매한 제품을 환불하고자 하는 경우 Amway의 환불 정책에 따라 대금 환급을 제공한다."
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-item" }, [
              _vm._v(
                "8) 사용자의 구매한 제품 반품 정책은 Amway의 반품 정책을 따른다."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "agree_layer_close", attrs: { type: "button" } },
          [_vm._v("닫기")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "txt_complete" }, [
      _c("i", { staticClass: "blt_complete" }),
      _vm._v("예약이 완료되었습니다.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_price" }, [
      _c("span", { staticClass: "product_value" }, [_vm._v("26,000")]),
      _vm._v("원 / "),
      _c("span", { staticClass: "product_value" }, [_vm._v("1")]),
      _vm._v("개")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-area" }, [
      _c("img", {
        attrs: {
          src: require("./images/banner.png"),
          alt: "엣모피어스 스카이 좋은 공기만으로 생활은 달라질 수 있습니다."
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29947928", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29947928","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/atmosphere-mask/apply.vue
// module id = null
// module chunks = 